// extracted by mini-css-extract-plugin
export default {"wrap":"TextBuildingBlockPreview_wrap__2uulL","content":"TextBuildingBlockPreview_content__1k7XB"};